module.exports = __webpack_public_path__ + "static/navy-337548494ddb541d7641df3c8039549c.png";